import {create} from "zustand/react";

export interface OrderState {
    searchText: string;
    selectedOrderId?: string;
    setSearchText: (text: string) => void;
    setSelectedOrderId: (id: string) => void;
}

export const useOrderStore = create<OrderState>((set, getState) => ({
    searchText: "",
    selectedOrderId: undefined,
    setSearchText: (text) => {
        set((state) => {
            return {
                ...state,
                searchText: text
            }
        })
    },
    setSelectedOrderId: (id) => {
        set((state) => ({
            ...state
        }));
    },
}));
